export enum ControlLabelEnum {
  ApartmentCityLabel = 'Miejscowość Twojej firmy',
  ApartmentCityRegistrationLabel = 'Miejscowość zameldowania',
  ApartmentNumberLabel = 'Numer mieszkania',
  ApartmentZipCodeLabel = 'Kod pocztowy Twojej firmy',
  ApartmentZipCodeRegistrationLabel = 'Kod pocztowy zameldowania',
  CarDamageStatusLabel = 'Czy samochód posiada jakieś uszkodzenia?',
  CarImportedFromUsaCanadaLabel = 'Sprowadzony z USA/Kanady',
  CarLeaseCompanyLabel = 'Od jakiej firmy leasingujesz pojazd?',
  CarMainOwner = 'Główny właściciel pojazdu',
  CarMileageInlineTooltip = 'tys. km',
  CarMileageLabel = 'Stan licznika w tys. km',
  CarNumberOfKeysLabel = 'Liczba kompletów kluczy',
  CarOwnerPurchaseYearLabel = 'Od którego roku jesteś użytkownikiem auta?',
  CarPreviousInsurerLabel = 'Ostatni ubezpieczyciel',
  CarRegistrationNumberLabel = 'Numer rejestracyjny',
  CarRegistrationNumberNotKnownLabel = 'Nie znam nr rejestracyjnego',
  CarRegistrationNumberShortLabel = 'Nr rejestracyjny',
  CarTypeLabel = 'Rodzaj pojazdu',
  CarUsageLabel = 'Użytkowanie samochodu',
  CarVersionIeLabel = 'Wersja Info-Ekspert',
  CarVersionLabel = 'Wersja',
  CarVinLabel = 'Numer VIN pojazdu',
  CarVinNrLabel = 'Nr VIN',
  CarVinShortLabel = 'VIN',
  CessionBankIdLabel = 'Nazwa banku',
  CessionBankZipCodeLabel = 'Kod pocztowy banku',
  CessionRequiredLabel = 'Czy potrzebujesz cesji dla banku?',
  CityLabel = 'Miejscowość',
  ContractSigner = 'Kto zawiera umowę?',
  CorrespondanceAddressSelection = 'Adres do korespondencji',
  DiscountCodeLabel = 'Kod rabatowy',
  EmailAddress = 'Adres e-mail',
  FirstRegistrationCountry = 'Miejsce pierwszej rejestracji',
  FirstRegistrationDateLabel = 'Data pierwszej rejestracji',
  HasInexperiencedAdditionalDriverLabel = 'Czy są dodatkowi kierowcy z prawem jazdy krócej niż 3 lata?',
  HomeAddressNotSameAsLegalLabel = 'Adres zamieszkania jest inny niż zameldowania',
  IHavePermissionToIssuePolicy = 'Mam zgodę na wystawienie polisy dla klienta',
  InexperiencedAdditionalDriverBirthDateLabel = 'Data urodzenia dodatkowego kierowcy',
  InexperiencedAdditionalDriverLicenseYearLabel = 'Kiedy dodatkowy kierowca uzyskał prawo jazdy kat. B?',
  InsuranceScopeLabel = 'Zaznacz wszystkie ubezpieczenia, które Cię interesują.',
  InsuranceStartDateLabel = 'Start ubezpieczenia',
  InsurantBusinessLegalStructureLabel = 'Jaka jest forma prawna Twojej działalności?',
  LastName = 'Nazwisko',
  LeasedTypeLabel = 'Rodzaj leasingu',
  LeasingCompanyLabel = 'Podaj dane firmy, od której leasingujesz pojazd',
  LeasingCompanyNameLabel = 'Nazwa firmy leasingowej',
  LeasingCompanyNipLabel = 'NIP firmy leasingowej',
  LegalStatusLeasedLabel = 'Czy samochód jest w leasingu?',
  MainOwnerHomeAddressCityLabel = 'Miejsce zamieszkania właściciela',
  MainOwnerHomeAddressZipCodeLabel = 'Kod pocztowy zamieszkania właściciela',
  MainOwnerLegalAddressCityLabel = 'Miejsce zameldowania właściciela',
  MainOwnerLegalAddressZipCodeLabel = 'Kod pocztowy zameldowania właściciela',
  Model = 'Model',
  ModelIe = 'Model Info-Ekspert',
  Name = 'Imię',
  NipNumberLabel = 'NIP Twojej firmy',
  OwnerBirthDateLabel = 'Data urodzenia właściciela',
  OwnerFamilyName = 'Nazwisko rodowe właściciela',
  OwnerHasChildrenLabel = 'Czy właściciel ma dzieci poniżej 26 roku życia?',
  OwnerLastName = 'Nazwisko właściciela',
  OwnerName = 'Imię właściciela',
  OwnerOccupationLabel = 'Zawód właściciela',
  OwnerOldestChildBirthYearLabel = 'Rok urodzenia najstarszego dziecka poniżej 26 roku życia',
  OwnerPesel = 'PESEL właściciela',
  OwnerTaxIdentificationNumberLabel = 'Działalność gospodarcza właściciela',
  PeselLabel = 'Numer PESEL',
  PhoneNumber = 'Numer telefonu',
  PhoneNumberPlaceholder = 'numer telefonu',
  PlannedUsageNightParkingPlaceLabel = 'Gdzie samochód będzie najczęściej parkowany nocą?',
  PlannedUsageYearlyMileageLabel = 'Ile kilometrów przejedzie samochód w ciągu najbliższych 12 miesięcy?',
  RiskAssessment = 'Ocena ryzyka',
  SecurityProtectionsLabel = 'Które zabezpieczenia antykradzieżowe zainstalowano w aucie?',
  SkpNumberPlaceholder = 'np. XXX/000/P',
  SteeringWheelOnTheRight = 'Kierownica po prawej stronie',
  StreetNameLabel = 'Ulica',
  StreetNumberLabel = 'Numer domu',
  YourPeselLabel = 'Twój numer PESEL',
  ZipCodeLabel = 'Kod pocztowy',
}
